import { useQuery } from '@tanstack/react-query';

import { getUseRegulatorsQueryOptions } from './options';

export default function useRegulators() {
    const options = getUseRegulatorsQueryOptions();
    return useQuery({ ...options, select: data => data.regulators });
}
